import ServicesV6 from "./ServicesV6";

export default ServicesV6;
